import React from "react";
import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import DashboardInternal from "./pages/Dashboard/Internal";
import DashboardExternal from "./pages/Dashboard/external";
import DashboardJne from "./pages/Dashboard/jne";
import DashboardAll from "./pages/Dashboard/all";
import DashboardBpjs from "./pages/Dashboard/bpjs";
import LayoutAdminExternal from "./components/LayoutAdmin/external";
import LayoutAdminInternal from "./components/LayoutAdmin/internal";
import DashboardDynamic from "./pages/Dashboard/dynamic";

const App = () => (
  <BrowserRouter>
    <Routes>
      <Route element={<LayoutAdminInternal />}>
        <Route path="/:id/:title" element={<DashboardDynamic />} />
      </Route>
      <Route element={<LayoutAdminInternal />}>
        <Route path="/JNE/:id/:title" element={<DashboardJne />} />
      </Route>
      <Route element={<LayoutAdminInternal />}>
        <Route path="/bpjs" element={<DashboardBpjs />} />
      </Route>
      <Route element={<LayoutAdminInternal />}>
        <Route path="/all" element={<DashboardAll />} />
      </Route>

      <Route element={<LayoutAdminExternal />}>
        <Route path="/external/:id" element={<DashboardExternal />} />
      </Route>
    </Routes>
  </BrowserRouter>
);

export default App;
